import { AutogenModelComments, AutogenRowComments } from "./autogen/AutogenModelComments";

export class ModelComments extends AutogenModelComments<RowComments> {
    constructor() {
        super(RowComments);
    }
}

export class RowComments extends AutogenRowComments {
}